import { useMutation } from '@tanstack/react-query';
import { ApiClient, apiPaths, useApiErrorStoreActions, isFetcherError } from '@repo/api/client';
import { loanAddResponseSchema } from './loan-add.schema';
var apiEndpoint = apiPaths.loan;
function postLoan(payload) {
    return ApiClient.fetch(apiEndpoint.path, {
        options: { method: 'POST', body: JSON.stringify(payload) },
        successSchema: loanAddResponseSchema,
        throw422: true,
    });
}
export function usePostLoanAdd() {
    var setApiError = useApiErrorStoreActions().setApiError;
    return useMutation({
        retry: false,
        mutationFn: postLoan,
        onError: function (error) {
            if (isFetcherError(error) && error.status === 422)
                return;
            setApiError({
                apiPathId: apiEndpoint.id,
                error: error,
            });
        },
    });
}
